export default "__VITE_ASSET__BataWrm1__"